/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbExportGapStatsGridDto } from './FcbExportGapStatsGridDto';
import {
    FcbExportGapStatsGridDtoFromJSON,
    FcbExportGapStatsGridDtoFromJSONTyped,
    FcbExportGapStatsGridDtoToJSON,
} from './FcbExportGapStatsGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbExportGapStatsGridDtoPaginatedResults
 */
export interface FcbExportGapStatsGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbExportGapStatsGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbExportGapStatsGridDto>}
     * @memberof FcbExportGapStatsGridDtoPaginatedResults
     */
    results?: Array<FcbExportGapStatsGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbExportGapStatsGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbExportGapStatsGridDtoPaginatedResults interface.
 */
export function instanceOfFcbExportGapStatsGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExportGapStatsGridDtoPaginatedResultsFromJSON(json: any): FcbExportGapStatsGridDtoPaginatedResults {
    return FcbExportGapStatsGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbExportGapStatsGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExportGapStatsGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbExportGapStatsGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbExportGapStatsGridDtoPaginatedResultsToJSON(value?: FcbExportGapStatsGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbExportGapStatsGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

